/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ln_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loan & EMI Calculator — Monthly Payment | Toolverse`)
};

const es_ln_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Préstamos e EMI — Pago Mensual | Toolverse`)
};

const de_ln_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darlehens- & EMI-Rechner — Monatliche Rate | Toolverse`)
};

const nl_ln_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lening- & EMI-calculator — Maandelijkse betaling | Toolverse`)
};

const fr_ln_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrice de prêt et d'EMI — Paiement mensuel | Toolverse`)
};

const it_ln_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore Prestiti e EMI — Pagamento Mensile | Toolverse`)
};

const pt_br2_ln_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Empréstimo e EMI — Pagamento Mensal | Toolverse`)
};

const pt_ln_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Empréstimo e EMI — Pagamento Mensal | Toolverse`)
};

const ja_ln_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「ローン & EMI計算機 — 月々の支払額 | Toolverse」`)
};

const zh_ln_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`贷款与EMI计算器 — 月供计算 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ln_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ln_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ln_meta_title", locale)
	if (locale === "en") return en_ln_meta_title(inputs)
	if (locale === "es") return es_ln_meta_title(inputs)
	if (locale === "de") return de_ln_meta_title(inputs)
	if (locale === "nl") return nl_ln_meta_title(inputs)
	if (locale === "fr") return fr_ln_meta_title(inputs)
	if (locale === "it") return it_ln_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_ln_meta_title(inputs)
	if (locale === "pt") return pt_ln_meta_title(inputs)
	if (locale === "ja") return ja_ln_meta_title(inputs)
	return zh_ln_meta_title(inputs)
};